import { Tooltip as AntdTooltip, TooltipProps } from "antd";

type TpProps = TooltipProps & {
  otherStyles?: TooltipProps["styles"];
};

const Tooltip = ({
  title,
  children,
  styles,
  placement,
  overlayInnerStyle,
  trigger = ["hover"],
  className,
  otherStyles,
}: TpProps) => {
  return (
    <AntdTooltip
      placement={placement}
      style={{
        fontFamily: "Google Sans",
        ...styles,
      }}
      title={title}
      trigger={trigger}
      overlayInnerStyle={{
        fontFamily: "Google Sans",
        minHeight: "auto",
        ...overlayInnerStyle,
      }}
      className={className}
      styles={otherStyles}
    >
      {children}
    </AntdTooltip>
  );
};

export default Tooltip;
